import { getMedlemskapstypeNamesAndDescriptions } from './Resources/medlemskapInformation';
import { ApiResource } from './ApiResource';
import { API_BASE_URL } from './apiUtils';

export interface Medlemskapstype {
    id: string;
    name: string;
    description: string;
    price: number;
    summaryTitle: string;
}

export interface MedlemskapstypeFromBackend {
    medlemskapskode: string;
    price: number;
}

export async function fetchMedlemskapstypeList(): Promise<ApiResource<Medlemskapstype[]>> {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Medlemskapstyper`);
        if (!response.ok) {
            return { status: 'error' };
        }
        const data = createMedlemskapstypeList(await response.json());
        return {
            status: 'ok',
            data,
        };
    } catch (error) {
        return { status: 'error' };
    }
}

function createMedlemskapstypeList(fromBackendList: MedlemskapstypeFromBackend[]): Medlemskapstype[] {
    const medlemskaptypeList: Medlemskapstype[] = fromBackendList
        .filter((medlemskap) => {
            return getMedlemskapstypeNamesAndDescriptions(medlemskap.medlemskapskode) !== null;
        })
        .map((medlemskap) => {
            const medlemskaptypeInformation = getMedlemskapstypeNamesAndDescriptions(medlemskap.medlemskapskode)!;

            return {
                ...medlemskap,
                id: medlemskap.medlemskapskode,
                name: medlemskaptypeInformation.name,
                description: medlemskaptypeInformation.description,
                summaryTitle: medlemskaptypeInformation.summaryTitle,
            };
        });
    return medlemskaptypeList;
}
